import React from "react";
import { Link, useOutletContext } from "react-router-dom";
import { UserInterface } from "../../../../core/components/user/domain/interfaces/user_interface";
import ThemeConstants from "../../../../config/theme/theme_constants";
import useWindowSize from "../../../../core/utils/use_windows_size";
import UvibesLogo from '../../../../assets/images/uvibes_logo.svg?react';
import UvibesIconGradient from '../../../../assets/images/uvibes_icon_gradient.svg?react';
import { useTranslation } from "../../../../i18n/useTranslation";

interface UserTitleProps {
  subtitle?: string;
  description?: string;
}

const UserTitle: React.FC<UserTitleProps> = ({ subtitle, description }) => {
  const { t } = useTranslation();
  const { firstname, profilePicture, company } = useOutletContext<UserInterface>();
  const { width } = useWindowSize();
  const theme = ThemeConstants();

  return (
    <div className="flex flex-col gap-4 lg:max-w-154">
      <div className={`flex max-sm:flex-col sm:flex-row-reverse ${subtitle ? 'items-start' : 'items-center'} sm:gap-4`}>
        <div className={`flex items-center gap-4 w-full justify-between ${subtitle ? 'max-sm:flex-row-reverse' : ''}`}>
          <Link to="/profile/me" className={`cursor-pointer w-13.5 h-13.5 ${subtitle ? '' : 'max-sm:mb-2'}`}>
            <img
              className="w-full h-full rounded-full object-cover"
              src={profilePicture}
              alt={t('common.avatar_alt', { firstname })}
              />
          </Link>
          {company && company.picture && company.permissions.whiteLabel === true ? <img src={company.picture} alt={t('common.logo_alt', { name: company.name })} className={`max-sm:h-10 sm:h-12 w-auto`}/> : width < 768 ? <UvibesIconGradient className='max-sm:h-10 sm:h-12 w-auto' style={{ color: theme.UvibesPink }}/> : <UvibesLogo className='max-sm:h-10 sm:h-12 w-auto'/>}
        </div>
        <div className="flex flex-col gap-2">
          <Link to="/profile/me" className='text-black text-xl font-bold cursor-pointer hover:underline whitespace-nowrap'>{subtitle ? t('common.greeting_with_subtitle', { firstname }) : t('common.greeting', { firstname })}</Link>
          {subtitle && <p style={{ color: theme.UvibesGray }}>
            {subtitle}
          </p>}
        </div>
      </div>
      {description && <p
        className="font-medium text-sm leading-snug max-sm:max-w-full max-lg:max-w-[75%] w-full"
        style={{ color: theme.UvibesGray }}
      >
        {description}
      </p>}
    </div>
  );
};

export default UserTitle;
